import React from "react";
import "./Reasons.css";
import image1 from "../../assets/gd1.png";
import image2 from "../../assets/gd2.png";
import image3 from "../../assets/gd3.png";
import image4 from "../../assets/gd4.png";
import nb from "../../assets/dlplatforms.jpeg";
import tick from "../../assets/tick.png";

const Reasons = () => {
	return (
		<section className="reasons" id="reasons">
			<div className="reasons-left">
				<div className="image-grid">
					<img src={image1} alt="Gym" className="grid-item-1" />
					<img src={image2} alt="Gym" className="grid-item-2" />
					<img src={image3} alt="Gym" className="grid-item-3" />
					<img src={image4} alt="Gym" className="grid-item-4" />
				</div>
			</div>
			
			<div className="reasons-right">
				<span className="section-subtitle outfit">Why Choose Grind'On?</span>
				
				<div className="section-title">
					<span className="stroke-text">The Elite </span>
					<span className="outfit">Training Standard</span>
				</div>

				<div className="reasons-details">
					<div className="reason-item">
						<div className="tick-container">
							<img src={tick} alt="tick" />
						</div>
						<div className="reason-content">
							<h4 className="outfit">Decade of Excellence</h4>
							<p>Over 10 years of transforming lives through expert coaching and science-backed training methods.</p>
						</div>
					</div>

					<div className="reason-item">
						<div className="tick-container">
							<img src={tick} alt="tick" />
						</div>
						<div className="reason-content">
							<h4 className="outfit">Train Smarter, Faster</h4>
							<p>Optimized programs designed to push your limits while ensuring maximum recovery and efficiency.</p>
						</div>
					</div>

					<div className="reason-item">
						<div className="tick-container">
							<img src={tick} alt="tick" />
						</div>
						<div className="reason-content">
							<h4 className="outfit">Premium Value</h4>
							<p>Get access to state-of-the-art equipment and elite training at competitive, accessible pricing.</p>
						</div>
					</div>

					<div className="reason-item">
						<div className="tick-container">
							<img src={tick} alt="tick" />
						</div>
						<div className="reason-content">
							<h4 className="outfit">Beginner to Pro</h4>
							<p>Full support system for newcomers and advanced athletes alike. We grow with you.</p>
						</div>
					</div>
				</div>

				<div className="reasons-footer">
					<span className="footer-label outfit">Our Trusted Partner</span>
					<div className="partners-logo">
						<a href="https://dlplatforms.com/" target="_blank" rel="noopener noreferrer">
							<img src={nb} alt="DL Platforms" />
						</a>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Reasons;
